import { jsonToInputParams } from 'library/util/graph';
import DataQuery from 'library/util/query';

import { resolve } from 'library/helpers/path-resolver';
import { NotificationRender } from 'library/components/notification';

const addOutcome = async ({
  uuid,
  outcome_id = '',
  included_goal_ids = [],
}) => {
  let mutationReturn = { success: false, errors: [] };
  try {
    const { data } = await addOutcomeMutation({
      uuid: uuid,
      outcomeId: outcome_id,
      includedGoalIds: included_goal_ids,
    });
    const { success, errors } = addOutcomeMutationParseQuery(data);
    mutationReturn.success = success;
    mutationReturn.errors = errors;

    if (errors.length > 0) console.error(errors);
  } catch (e) {
    console.error(`Error: ${e}`);
    mutationReturn.errors = 'There was an unknown error.';
  }
  return mutationReturn;
};

const addOutcomeMutation = async ({
  uuid,
  outcomeId,
  includedGoalIds,
  isRecommendation,
}) => {
  const params = {
    uuid: uuid,
    outcome_id: outcomeId,
    included_goal_ids: includedGoalIds,
  };

  const mutation = isRecommendation
    ? 'accept_recommended_outcome'
    : 'add_outcome_to_user_with_inclusions';
  return await DataQuery(
    `mutation {
        submit_outcome:${mutation}(
          ${jsonToInputParams(params)}
        ) {
          errors
          success
        }
      }`
  );
};

const addOutcomeMutationParseQuery = (data) => ({
  errors: resolve(data, 'submit_outcome/errors', []),
  success: resolve(data, 'submit_outcome/success', false),
});

const addOutcomeAction = async (
  user,
  outcome,
  configuration,
  reloadOutcomes
) => {
  try {
    const { data } = await addOutcomeMutation({
      uuid: user.uuid,
      outcomeId: outcome.id,
      includedGoalIds: outcome.goals.map(({ id }) => id),
      isRecommendation: true,
    });
    const { success, errors } = addOutcomeMutationParseQuery(data);
    const notificationType = success ? 'success' : 'error';
    const message = success
      ? `The ${resolve(
          configuration,
          'environment/journey/goals_name',
          'outcome'
        )} has successfully been added.`
      : `There was an error adding your ${resolve(
          configuration,
          'environment/journey/goals_name',
          'outcome'
        )}`;
    NotificationRender(notificationType, message);
    reloadOutcomes();
    if (resolve(errors, 'length', 0) > 0) console.error(errors);
  } catch (e) {
    console.error(e);
    NotificationRender(
      'error',
      `There was an error adding your ${resolve(
        configuration,
        'environment/journey/goals_name',
        'outcome'
      )}`
    );
  }
};

export {
  addOutcome,
  addOutcomeMutation,
  addOutcomeMutationParseQuery,
  addOutcomeAction,
};
